// =====================================================
// TYPES: USER
// Description: Types TypeScript pour les utilisateurs
// =====================================================

export type UserRole = 'superadmin' | 'admin' | 'user';

export interface User {
  id: string;
  email: string;
  full_name: string;
  role: UserRole;
  created_at: string;
  last_sign_in_at?: string;
  last_active_at?: string;
}

export interface UpdateUserDto {
  role?: UserRole;
}

export interface ChangePasswordDto {
  newPassword: string;
}

export const USER_ROLES: UserRole[] = ['admin', 'user'];
export const ALL_USER_ROLES: UserRole[] = ['superadmin', 'admin', 'user'];

export const USER_ROLE_LABELS: Record<UserRole, string> = {
  superadmin: 'Admin',
  admin: 'Désertours',
  user: 'Asso 4L',
};
